<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            id="halbsGrid"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [allowColumnReordering]="true"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'halbs-grid-state', savingTimeout: 0 }"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="number"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-search-panel
                [visible]="true"
                placeholder="Search"
            ></dxo-search-panel>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Halbs</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item name="exportButton"></dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('number')" caption="ID" [minWidth]="100" cellTemplate="numberTemplate" [sortOrder]="'asc'"></dxi-column>
            <dxi-column [dataField]="gridFieldName('description')" caption="Description" [minWidth]="200"></dxi-column>
            <dxi-column [dataField]="gridFieldName('materialType')" caption="Material Type" [minWidth]="120"></dxi-column>
            <dxi-column [dataField]="gridFieldName('mdrRecordOwner')" caption="MDR Record Owner" [minWidth]="150"></dxi-column>
            <dxi-column [dataField]="gridFieldName('imspShared')" caption="IMSP Shared" [minWidth]="120"></dxi-column>
            <dxi-column [dataField]="gridFieldName('fullPallet')" caption="Full Pallet" [minWidth]="100" dataType="number" selectedFilterOperation=">=" alignment="left"></dxi-column>
            <dxi-column
                [dataField]="gridFieldName('storageType')"
                caption="Revised Storage Type"
                [lookup]="{ dataSource: binTypeOptions, valueExpr: 'value', displayExpr: 'text' }"
                [minWidth]="180"
            ></dxi-column>
            <dxi-column [dataField]="gridFieldName('materialGroup')" caption="Material Group" [minWidth]="150"></dxi-column>

            <div *dxTemplate="let cellInfo of 'numberTemplate'">
                <div class="text-primary fw-semibold">
                    <a [routerLink]="`/inventory/halb/details/${getCellData(cellInfo).number}`"
                       class="text-decoration-none">{{ getCellData(cellInfo).number }}</a>
                </div>
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="filterModelName('number')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'ID', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('description')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Description', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('materialType')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Material Type', stylingMode: 'filled' }"
            ></dxi-item>
             <dxi-item
                [dataField]="filterModelName('mdrRecordOwner')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'MDR Record Owner', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('imspShared')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'IMSP Shared', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('fullPallet')"
                editorType="dxNumberBox"
                [editorOptions]="{ placeholder: 'Full Pallet', stylingMode: 'filled' }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('storageType')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: binTypeOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Revised Storage Type', stylingMode: 'filled' }"
            ></dxi-item>
             <dxi-item
                [dataField]="filterModelName('materialGroup')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Material Group', stylingMode: 'filled' }"
            ></dxi-item>
        </dx-form>
    </filter-panel>
</div>

